/* 班线调度 */
<template>
  <div id="schedulingDispatch">
    <custom-table ref="customTable" has-organization="true" :customOptions="customOptions" :columns="columns">

      <template slot="customTable-top">
        <div style="display: flex; align-items: center; margin-bottom: 16px; gap: 12px;">
          <customAcrossRoll ref="customAcrossRoll" style="flex: 1;">
            <div v-for="(schedulingTime, i) in schedulingTimeList" :key="i" class="date"
              :class="schedulingTimeActive == schedulingTime ? 'active' : ''"
              @click="schedulingTimeClick(schedulingTime)">
              <span class="date-text">
                {{ getWeek(schedulingTime) }}
                {{ schedulingTime | filterTime("MM-DD") }}
              </span>
            </div>
          </customAcrossRoll>
          <el-date-picker
            v-model="jumpDate"
            type="date"
            placeholder="跳转到指定日期"
            size="small"
            value-format="timestamp"
            style="width: 160px; flex-shrink: 0;"
            @change="onDateJump"
          />
        </div>
      </template>

      <template slot="search-bottom">
        <div style="margin-bottom: 16px; color: #999;">注意：班次调度仅支持标准模式线路</div>
      </template>


      <template slot-scope="{item, row}">
        <template v-if="item.prop == 'registerTime'">{{ row.registerTime | filterTime }}</template>
        <template v-else-if="item.prop == 'status'">
          <span v-if="row.status == 1 && row.isEnabled == 1" style="color:#009900">正售</span>
          <span v-else style="color: #999">停售</span>
        </template>

        <template v-else-if="item.prop == 'startStationName'">
          {{ row.startStationName }} - {{ row.endStationName }}
        </template>
        <template v-else-if="item.prop == 'licenseNo'" style="justify-content: center;">
          <el-button type="text" v-if="row.licenseNo" @click="viewVehicle(row)">
            <span :style="getPlateStyle(row.licenseNo)">{{ formatPlateNumber(row.licenseNo) }}</span>
          </el-button>
          <el-button type="text" v-else @click="editVehicle(row)">添加</el-button>
        </template>
        <template v-else-if="item.prop == 'driverName'">
          <el-button type="text" v-if="row.driverName" @click="viewVehicle(row)">{{ row.driverName }}</el-button>
          <el-button type="text" v-else style="color: #999;">-</el-button>
        </template>
        <template v-else-if="item.prop == 'startTime'">{{ row.startTime }} - {{ row.endTime }}</template>
        <template v-else-if="item.prop == 'departureRestrictionsConfig'">
          <span v-if="row.departureRestrictionsConfig">
            可提前{{ row.departureRestrictionsConfig }}分钟发车
            <el-button type="text" @click="editDepartureRestrictionsConfig(row)">解除</el-button>
          </span>
          <span v-else>-</span>
        </template>
        <template v-else-if="item.prop == 'vehicleSeat'">
          <span v-if="row.vehicleSeat">
            {{ row.vehicleSeat }}
            <span style="color: #999" v-if="row.followPersonnelSeat">(随车:{{ row.followPersonnelSeat }})</span>
          </span>
          <span v-else>-</span>
        </template>
        <template v-else-if="item.prop == 'fee'">￥{{ row.fee }}</template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : '-' }}</template>
      </template>

      <template slot="table-operation" v-if="schedulingTimeActive >= new Date().setHours(0, 0, 0, 0) / 1000">
        <el-table-column label="操作" fixed="right" width="200px" v-slot="{ row }">
          <el-button type="text" @click="statusChange(row)">{{ row.status == 1 && row.isEnabled == 1 ? '停售' : '启售' }}</el-button>
          <el-dropdown @command="handleCommand($event, row)">
            <span class="el-dropdown-link" style="font-size:12px;color:#409EFF;cursor:pointer;margin-left:8px;">
              更多<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" v-if="row.licenseNo">
              <el-dropdown-item command="openChangeDialog">更换车辆/司机</el-dropdown-item>
            </el-dropdown-menu>
            <el-dropdown-menu slot="dropdown" v-else>
              <el-dropdown-item command="editVehicle">设置值班车辆</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-table-column>
      </template>
    </custom-table>


    <!-- 值班车辆 -->
    <schedulingVehicle @confirm="saveVehicle" v-if="visibleEditVehicle" :visible.sync="visibleEditVehicle"
      :line="lineInfo" :scheduling="editShiftForm" :multiple="false" :lineOId="lineInfo.organizationId" />

    <el-dialog title="值班车辆调整" :visible.sync="dialogVisible" width="500px" :before-close="handleClose"
      :close-on-click-modal="false" :destroy-on-close="true">
      <div>
        <div class="flex">
          <span class="label">班次线路</span>
          <span>{{ editShiftForm.startStationName }} - {{ editShiftForm.endStationName }}</span>
        </div>
        <div class="flex">
          <span class="label">班次时间</span>
          <span>{{ editShiftForm.startTimeStamp | filterTime("MM-DD") }} {{ editShiftForm.startTime }} - {{
            editShiftForm.endTime }}</span>
        </div>
        <div class="choose flex" v-if="!chooseType">
          <div class="chooseItem" @click="chooseItem('all')">
            <img class="bg" src="../../../assets/img/change_bg.png" alt="">
            <img src="../../../assets/img/change_all.png" alt="">
            <div>同时更换</div>
            <div>车辆与司机</div>
          </div>
          <div class="chooseItem" @click="chooseItem('vehicle')">
            <img class="bg" src="../../../assets/img/change_bg.png" alt="">
            <img src="../../../assets/img/change_ve.png" alt="">
            <div>仅更换车辆</div>
          </div>
          <div class="chooseItem" @click="chooseItem('driver')">
            <img class="bg" src="../../../assets/img/change_bg.png" alt="">
            <img src="../../../assets/img/change_driver.png" alt="">
            <div>仅更换司机</div>
          </div>
        </div>
        <div v-else v-loading="chooseLoading">
          <div class="blueInfo">
        <p>1.仅可更换同一机构下的车辆和司机</p>
        <p>2.更换后的车辆座位数不可低于已售车票数量</p>
      </div>
          <div class="flex changeItem" v-if="chooseType == 'all'">
            <span class="label">值班车辆</span>
            <div style="flex: 1;">
              <el-select v-model="currentVehicleAndDriver" placeholder="输入车辆号牌/司机姓名搜索" filterable clearable style="width: 100%;">
                <el-option v-for="item in allList" :key="item.id"
                  :label="item.licenseNo + '  ' + item.driverName + '  '  + item.vehicleSeat + '座'" :value="item.id"
                  :disabled="item.licenseNo == editShiftForm.licenseNo || editShiftForm.soldTickets > item.vehicleSeat - 1">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="flex changeItem" v-if="chooseType == 'vehicle'">
            <span class="label">值班车辆</span>
            <div style="flex: 1;">
              <el-select v-model="currentVehicle" placeholder="输入车辆号牌搜索" filterable clearable style="width: 100%;">
                <el-option v-for="item in vehicleList" :key="item.id"
                  :label="item.licenseNo + '  ' + item.vehicleSeat + '座'" :value="item.id"
                  :disabled="item.licenseNo == editShiftForm.licenseNo || editShiftForm.soldTickets > item.vehicleSeat - 1">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="flex changeItem" v-if="chooseType == 'driver'">
            <span class="label">值班司机</span>
            <div style="flex: 1;">
              <el-select v-model="currentDriver" placeholder="输入司机姓名搜索" filterable clearable style="width: 100%;">
                <el-option v-for="item in driverList" :key="item.id" :label="item.name + '  ' + item.phone"
                  :value="item.id" :disabled="item.id == editShiftForm.driverId">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="chooseType">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureChange">确 定</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>


export default {
  name: "schedulingDispatch",
  components: {
    customAcrossRoll: () => import("@/components/custom-across-roll.vue"),
    schedulingVehicle: () => import("../../scheduling/customize/schedulingVehicle.vue"),
  },
  data() {
    return {
      dialogVisible: false,
      schedulingTimeActive: null,
      schedulingTimeList: [],
      // 配置项
      customOptions: {
        // 请求的列表url
        url: '/api/v1/manage/line/scheduling/dispatch',
        params: {
          schedulingTime: this.$route.query.schedulingTime ? this.$route.query.schedulingTime : new Date().setHours(0, 0, 0, 0) / 1000,
          page: 1, // 页数
          size: 20 // 每页条数
        },
        search: [
          {
            type: "select", field: "lineId", name: "搜索线路", value: null,
            filterable: true,
            props: { label: 'stationName', value: 'id', },
            option: []
          },
          { type: "input", field: "licenseNo", name: "车辆号牌", value: "" },
          { type: "input", field: "vehicleNo", name: "车辆编号", value: "" },
          { type: "input", field: "driverName", name: "司机姓名", value: "" },
          {
            type: "select", field: "status", name: "售票状态", value: null,
            option: [
              { value: 1, label: "正售" },
              { value: 2, label: "停售" }
            ],
          },
          {
            type: "select", field: "registerType", name: "报班状态", value: null,
            option: [
              { value: 0, label: "未报到" },
              { value: 1, label: "已报到" }
            ],
          },
        ]
      },
      // 表头
      columns: [
        { prop: 'status', label: '售票状态', minWidth: 80 },
        { prop: 'startStationName', label: '线路名称', minWidth: 200  },
        { prop: "startTime", label: "班次", minWidth: 120 },
        { prop: 'licenseNo', label: '值班车辆', minWidth: 150 },
        { prop: "vehicleNo", label: "车辆编号", minWidth: 120 },
        { prop: "vehicleModel", label: "车型", minWidth: 120 },
        { prop: "vehicleSeat", label: "座位数", minWidth: 80 },
        { prop: "driverName", label: "值班司机", minWidth: 100 },
        { prop: "soldTickets", label: "已售票", minWidth: 60 },
        { prop: "remainingTickets", label: "余票", minWidth: 60 },
        { prop: "departureRestrictionsConfig", label: "发车限制", width: 160 },
        // { prop: "driverName", label: "值班司机", minWidth: 135 },
      ],
      lineInfo: null,
      editShiftForm: {},
      visibleEditVehicle: false,
      visibleChangeVehicle: false,
      visibleEditDriver: false,
      driverList: [],
      vehicleList: [],
      allList: [],
      currentVehicle: null,
      currentDriver: null,
      currentVehicleAndDriver: null,
      chooseType: null,
      chooseLoading: false,
      jumpDate: null
    }
  },
  created() {
    this.loadSchedulingTimeList();
  },
  methods: {
    editDepartureRestrictionsConfig(row) {
      this.$confirm('解除后，司机可随时发车，是否确认解除？', '解除发车限制', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
      }).then(async () => {
        let url = "/api/v1/manage/line/departureRestrictions/scheduling/exempt";
        let params = {
          schedulingId: row.schedulingId
        };
        let data = await this.$axios.post(url, params);
        if (data && data.code == 1) {
          this.$message.success('发车限制解除成功');
          this.$refs.customTable.listFn()
        }
      })
    },
    openChangeDialog(row) {
      this.editShiftForm = { ...row };
      this.dialogVisible = true;
      this.chooseType = null;
    },
    handleCommand(cmd, row) {
      this.editShiftForm = { ...row };
      if (cmd === 'editVehicle') {
        this.lineInfo = { organizationId: row.organizationId };
        this.visibleEditVehicle = true;
      } else if (cmd === 'openChangeDialog') {
        this.dialogVisible = true;
        this.chooseType = null;
      }
    },
    onDateJump(ts) {
      if (!ts) return;
      const dayTs = ts / 1000;
      if (!this.schedulingTimeList.includes(dayTs)) {
        const minTime = new Date().setHours(-72, 0, 0, 0) / 1000;
        let list = [];
        for (let i = 0; i < 33; i++) {
          list.push(minTime + 86400 * i);
        }
        if (!list.includes(dayTs)) {
          list.unshift(dayTs);
          list.sort((a, b) => a - b);
        }
        this.schedulingTimeList = list;
      }
      this.schedulingTimeClick(dayTs);
    },
    async chooseItem(key) {
      this.currentDriver = null
      this.currentVehicle = null
      this.currentVehicleAndDriver = null
      const allUrl = "/api/v1/manage/vehicle"
      const driverUrl = "/api/v1/manage/line/scheduling/dispatch/driver/list";
      const vehicleUrl = "/api/v1/manage/line/scheduling/dispatch/vehicle/list";
      let params = {
        organizationId: this.editShiftForm.organizationId
      }
      this.chooseLoading = true;
      try {
        switch (key) {
          case 'all': {
            const {code, data} = await this.$axios.get(allUrl, { params });
            if (code == 1) {
              this.allList = (data || []).filter(item => item.driverId);
            }
            break;
          }
          case 'vehicle': {
            const {code: cCode, data: vData} = await this.$axios.get(vehicleUrl, { params });
            if (cCode == 1) {
              this.vehicleList = vData || [];
            }
            break;
          }
          case 'driver': {
            const {code: dCode, data: dData} = await this.$axios.get(driverUrl, { params });
            if (dCode == 1) {
              this.driverList = dData || [];
            }
            break;
          }
        }
      } finally {
        this.chooseLoading = false;
      }
      this.chooseType = key
    },
    handleClose() {
      this.dialogVisible = false;
    },
    /* 初始化前三天、未来30天时间戳 */
    loadSchedulingTimeList() {
      let minTime = new Date().setHours(-72, 0, 0, 0) / 1000;
      let today = new Date().setHours(0, 0, 0, 0) / 1000; // 当天0点
      let schedulingTimeList = [];
      for (let i = 0; i < 33; i++) {
        schedulingTimeList.push(minTime + 86400 * i);
      }
      this.schedulingTimeActive = this.$route.query.schedulingTime ? this.$route.query.schedulingTime : today;
      this.schedulingTimeList = schedulingTimeList;
    },
    getWeek(timestamp) {
      let date = new Date(timestamp * 1000);
      let yesterday = new Date().setHours(-24, 0, 0, 0); // 昨天
      let today = new Date().setHours(0, 0, 0, 0); // 今天
      let tomorrow = new Date().setHours(24, 0, 0, 0); // 明天
      var week;
      if (date.getDay() == 0) week = "周日";
      if (date.getDay() == 1) week = "周一";
      if (date.getDay() == 2) week = "周二";
      if (date.getDay() == 3) week = "周三";
      if (date.getDay() == 4) week = "周四";
      if (date.getDay() == 5) week = "周五";
      if (date.getDay() == 6) week = "周六";
      if (date.getTime() == yesterday) week = "昨日";
      if (date.getTime() == today) week = "今日";
      if (date.getTime() == tomorrow) week = "明日";
      return week;
    },
    /* 点击时间戳 */
    schedulingTimeClick(schedulingTime) {
      this.schedulingTimeActive = schedulingTime;
      this.customOptions.params.schedulingTime = schedulingTime
      this.$refs.customTable.listFn()
    },

    /* 开启/停止 售票 */
    statusChange(row) {
      let title = row.isEnabled == 1 ? '停止售票' : '开启售票'
      let content = row.isEnabled == 1 ? '停止该班次售票后，乘客将无法购票，确认这样做吗？' : '确认开启该班次售票吗？'
      this.$confirm(content, title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let params = {
          schedulingId: row.schedulingId,
          isEnabled: row.isEnabled == 1 ? 2 : 1
        };
        let url = "/api/v1/manage/line/scheduling/isEnabled";
        let { code } = await this.$axios.post(url, params);
        if (code == 1) {
          this.$message({ type: "success", message: `班次已${params.isEnabled == 1 ? '开启' : '停止'}售票` });
          this.$refs.customTable.listFn()
        }
      }).catch(() => {
      });

    },

    async getLineInfo(row, visibleKey) {
      let url = "/api/v1/manage/line/scheduling/" + row.lineId;
      let res = await this.$axios.get(url, { channel: 1 });
      if (res?.code == 1 && res.data) {
        this.lineInfo = res.data.line;
        this.editShiftForm = { ...row };
        this[visibleKey] = true;
      }
    },

    /* 值班车辆 */
    async editVehicle(row) {
      this.getLineInfo(row, 'visibleEditVehicle')
    },
    async viewVehicle(row) {
      this.chooseType = null
      this.getLineInfo(row, 'dialogVisible')
    },
    /* 确定值班车辆 */
    async saveVehicle(result) {
      let url = "/api/v1/manage/line/scheduling/vehicle";
      let params = {
        schedulingId: this.editShiftForm.schedulingId,
        ...result[0]
      };
      let data = await this.$axios.post(url, params);
      if (data && data.code == 1) {
        this.$message.success('值班车辆绑定成功');
        this.$refs.customTable.listFn();
      }
    },
    sureChange() {
      if(this.chooseType == 'vehicle' && !this.currentVehicle){
        return this.$message.error('请选择要调整车辆')
      }
      if(this.chooseType == 'driver' && !this.currentDriver){
        return this.$message.error('请选择要调整司机')
      }
      if(this.chooseType == 'all' && !this.currentVehicleAndDriver){
        return this.$message.error('请选择要调整车辆')
      }

      if(this.chooseType == 'vehicle'){
        this.changeVehicle(this.currentVehicle)
      } else if(this.chooseType == 'driver'){
        this.saveDriver(this.currentDriver)
      } else {
        let cItem = this.allList.find(item => {
          return item.id == this.currentVehicleAndDriver
        })
        this.changeVehicleAndDriver(cItem.id, cItem.driverId)
      }
      
    },
    /* 确定更换车辆和司机 */
    async changeVehicleAndDriver(vId, dId) {
      let url = "/api/v1/manage/line/scheduling/dispatch/driverAndVehicle";
      let params = {
        schedulingId: this.editShiftForm.schedulingId,
        vehicleId: vId,
        driverId: dId
      };
      let data = await this.$axios.post(url, params);
      if (data && data.code == 1) {
        this.$message.success('班次车辆与司机更换成功');
        this.$refs.customTable.listFn();
        this.dialogVisible = false
      }
    },
    /* 确定更换车辆 */
    async changeVehicle(id) {
      let url = "/api/v1/manage/line/scheduling/dispatch/vehicle";
      let params = {
        schedulingId: this.editShiftForm.schedulingId,
        vehicleId: id
      };
      let data = await this.$axios.post(url, params);
      if (data && data.code == 1) {
        this.$message.success('班次车辆更换成功');
        this.$refs.customTable.listFn();
        this.dialogVisible = false
      }
    },
    /* 确定更换司机 */
    async saveDriver(id) {
      let url = "/api/v1/manage/line/scheduling/dispatch/driver";
      let params = {
        schedulingId: this.editShiftForm.schedulingId,
        driverId: id
      };
      let data = await this.$axios.post(url, params);
      if (data && data.code == 1) {
        this.$message.success('班次司机更换成功');
        this.$refs.customTable.listFn();
        this.dialogVisible = false
      }
    },
  }
}
</script>

<style lang="less" scoped>
#schedulingDispatch {
  margin-top: 10px;
  // 日期选择
  .date {
    min-width: 80px;
    padding: 10px 16px;
    text-align: center;
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    background: #fff;
    
    &:hover {
      border-color: #2B77FF;
      color: #2B77FF;
    }
    
    &.active {
      background: #2B77FF;
      border-color: #2B77FF;
      color: #fff;
    }
    
    .date-text {
      font-size: 13px;
      font-weight: 500;
    }
  }

  // 提示信息
  .blueInfo {
    background: #f0f7ff;
    border-radius: 6px;
    padding: 12px 16px;
    color: #2B77FF;
    font-size: 13px;
    margin: 12px 0;
    border: 1px solid #d4e8ff;
    
    p {
      margin: 4px 0;
    }
  }

  // 表格按钮
  :deep(.el-table) {
    .el-button--text {
      color: #2B77FF;
      
      &:hover {
        color: #1a5fd9;
      }
    }
  }

  // 弹窗样式
  :deep(.el-dialog) {
    border-radius: 8px;
    
    .el-dialog__header {
      padding: 16px 20px;
      border-bottom: 1px solid #ebeef5;
      
      .el-dialog__title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
      }
    }
    
    .el-dialog__body {
      padding: 20px;
    }
    
    .el-dialog__footer {
      padding: 12px 20px;
      border-top: 1px solid #ebeef5;
      
      .el-button {
        border-radius: 6px;
      }
    }
  }
}

.label {
  width: 100px;
  font-weight: 500;
  color: #606266;
  flex-shrink: 0;
}

.flex {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px dashed #ebeef5;
  
  &:last-child {
    border-bottom: none;
  }
}

.changeItem {
  margin-top: 12px;
  padding: 12px 0;
  
  .el-select {
    width: 100%;
  }
}

.choose {
  margin-top: 16px;
  justify-content: space-between;
  gap: 16px;
}

.chooseItem {
  width: 120px;
  height: 140px;
  background: linear-gradient(180deg, #4CBFFF 0%, #2B77FF 100%);
  box-shadow: 0 4px 12px rgba(43, 119, 255, 0.3);
  border-radius: 10px;
  position: relative;
  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 22px;
  text-align: center;
  padding-top: 32px;
  box-sizing: border-box;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(43, 119, 255, 0.4);
  }
  
  img {
    width: 44px;
    height: 44px;
  }

  .bg {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 53px;
    height: 53px;
    opacity: 0.3;
  }
}
</style>
